import { apiDate, boolean, number, optional, optionalString, string, uuid, zodLess, ZodLessInfer } from '@kaiizen/zod-less';
import { optionalNumberOrNumberFromString } from './schemaLib';

export const ApiIssueVideoSubmissionSchema = zodLess({
  id: uuid,
  orgId: uuid,
  propertyProjectId: uuid.optional(),
  scanId: uuid.optional(),
  userId: uuid,
  s3Key: string,
  originalFileName: string,
  contentType: string,
  sizeBytes: number,
  note: optionalString,
  playbackUrl: optionalString,
  userName: optionalString,
  orgName: optionalString,
  projectName: optionalString,
  createdAt: apiDate,
  updatedAt: apiDate,
});
export type ApiIssueVideoSubmission = ZodLessInfer<typeof ApiIssueVideoSubmissionSchema>;

export const ApiIssueVideoSubmissionListQuerySchema = zodLess({
  projectId: uuid.optional(),
  scanId: uuid.optional(),
  userId: uuid.optional(),
  limit: optionalNumberOrNumberFromString,
});
export type ApiIssueVideoSubmissionListQuery = ZodLessInfer<typeof ApiIssueVideoSubmissionListQuerySchema>;

export const ApiIssueVideoSubmissionListResponseSchema = zodLess({
  submissions: [ApiIssueVideoSubmissionSchema],
});
export type ApiIssueVideoSubmissionListResponse = ZodLessInfer<typeof ApiIssueVideoSubmissionListResponseSchema>;

export const ApiInitIssueVideoUploadSchema = zodLess({
  projectId: uuid.optional(),
  scanId: uuid.optional(),
  note: optionalString,
  fileName: string,
  contentType: string,
  sizeBytes: number,
});
export type ApiInitIssueVideoUpload = ZodLessInfer<typeof ApiInitIssueVideoUploadSchema>;

export const ApiInitIssueVideoUploadResponseSchema = zodLess({
  issueVideoId: uuid,
  objectKey: string,
  uploadUrl: string,
  expiresAt: apiDate,
  maxSizeBytes: number,
});
export type ApiInitIssueVideoUploadResponse = ZodLessInfer<typeof ApiInitIssueVideoUploadResponseSchema>;

export const ApiCompleteIssueVideoUploadSchema = zodLess({
  issueVideoId: uuid,
  objectKey: string,
  sizeBytes: number,
  durationMs: optional(number),
  note: optionalString,
});
export type ApiCompleteIssueVideoUpload = ZodLessInfer<typeof ApiCompleteIssueVideoUploadSchema>;

export const ApiCompleteIssueVideoUploadResponseSchema = zodLess({
  ok: boolean,
  issueVideoId: uuid,
});
export type ApiCompleteIssueVideoUploadResponse = ZodLessInfer<typeof ApiCompleteIssueVideoUploadResponseSchema>;
